// Optional controllers for server-rendered marketing widgets. Load them at
// bootstrap when their markup exists, not at the first click on the widget.
export async function registerPresentControllers(app, loaders, root = document,
  onError = (name, error) => console.error(`[marketing] ${name} failed to load:`, error)) {
  await Promise.all(Object.entries(loaders).map(async ([name, load]) => {
    if (!root.querySelector(`[data-controller~="${name}"]`)) return;
    try {
      const controller = await load();
      app.register(name, controller.default);
    } catch (error) {
      onError(name, error);
    }
  }));
}
